// AI Generated: Entry point for Home page
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import configureHomeStore from '$ind/stores/home.store';
import App from '$ind/components/home/App';

// Error boundary wrapper
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error: any }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.error('React Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', color: 'red' }}>
          <h1>Something went wrong.</h1>
          <pre>{this.state.error?.toString()}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

try {
const rootElement = document.getElementById('root');
  if (!rootElement) {
    console.error('Root element not found');
    throw new Error('Root element not found');
  }

const root = createRoot(rootElement);

// Get SSR preloaded state from window
const preloadedState = (window as any).__PRELOADED_STATE__ || {};
delete (window as any).__PRELOADED_STATE__;

// Get initial props from window
const initialProps = (window as any).__INITIAL_PROPS__ || {
  isMobile: false,
  isDesktop: true,
};

const store = configureHomeStore(preloadedState);

root.render(
    <ErrorBoundary>
  <Provider store={store}>
    <App {...initialProps} />
  </Provider>
    </ErrorBoundary>
);
} catch (error) {
  console.error('Failed to initialize app:', error);
  document.body.innerHTML = `<div style="padding: 20px; color: red;"><h1>Failed to load</h1><pre>${error}</pre></div>`;
}
// AI Generated: End of home entry point

